<template>
  <div class="d-flex flex-column w-100 align-items-center" dir="rtl" v-if="data">
    <div class="f30-l44 margin-top-50 margin-bottom-20 text-center">העמוד שחיפשתם לא קיים</div>
    <!-- todo fix link url -->
    <SvgImage class="margin-top-20"  src="https://staging.yummi.co.il/images/not_found_error.svg" style="height:300px;" />
    <ButtonComponent class="margin-top-20" caption="חזרה לדף הבית" link="/"></ButtonComponent>
  </div>
</template>
<script>
import SvgImage from "@/components/generic/SvgImage";
import ButtonComponent from "@/components/form/ButtonComponent";
export default {
  components: {
    SvgImage,
    ButtonComponent
  },
  data() {
    return {
      data: {}
    }
  },
  mounted() {
    const d = this.$route.params.d;
    if (d) {
      this.data = JSON.parse(d);
    }

  },

}
</script>